module.exports = __webpack_public_path__ + "static/media/logo102.43f28ecd.png";